import { portalText } from './i18n';

export function initCustomFileInputs(root = document) {
    root.querySelectorAll('#frm-jobForm-cv:not([data-custom-file-ready])').forEach(file => {
        file.dataset.customFileReady = 'true';
        file.classList.add('custom-file-upload-hidden');
        file.tabIndex = -1;

        const wrapper = document.createElement('div');
        wrapper.className = 'file-upload-wrapper';
        const display = document.createElement('input');
        display.type = 'text';
        display.className = 'form-control file-upload-input';
        display.readOnly = true;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'file-upload-button';
        button.textContent = portalText('attach');
        button.tabIndex = -1;

        file.after(wrapper);
        wrapper.append(file, display, button);

        button.addEventListener('click', () => file.click());
        file.addEventListener('change', () => {
            const filename = Array.from(file.files ?? [], item => item.name).join(', ');
            display.value = filename;
            display.title = filename;
            display.focus();
        });
        display.addEventListener('keydown', event => {
            if (event.key === 'Enter') {
                event.preventDefault();
                file.click();
            } else if (event.key === 'Backspace' || event.key === 'Delete') {
                event.preventDefault();
                file.value = '';
                display.value = '';
                display.title = '';
            }
        });
        display.addEventListener('blur', () => file.dispatchEvent(new Event('blur')));
    });
}
